module.exports = __webpack_public_path__ + "img/Worthington_Bill_crop.20b3f310.jpeg";